<template>
  <section
    v-if="isVisible"
    class="kd-layer-settings"
    :style="layerStyle"
    ref="settings"
  >
    <!-- <div style="position: absolute; top: -20px; left: -20px;">
      Layer Settings for: {{ ACTIVE_LAYER.id }}
    </div> -->
    <kd-image-layer-settings
      v-if="layer.type === 'foto'"
    ></kd-image-layer-settings>
    <kd-text-layer-settings
      v-if="layer.type === 'text'"
    ></kd-text-layer-settings>
    <div
      class="kd-layer-settings__arrow"
      :class="[
        `kd-layer-settings__arrow--${arrowDiretion}`,
      ]"
      :style="arrowStyle"
    ></div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import KdImageLayerSettings from '@/components/KdImageLayerSettings.vue';
import KdTextLayerSettings from '@/components/KdTextLayerSettings.vue';

import {
  ACTIVE_LAYER_ID,
  ACTIVE_LAYER,
  ACTIVE_LAYER_BOUNDING_CLIENT_RECT,
  WINDOW_WIDTH,
  WINDOW_HEIGHT,
} from '@/store/getter-types';

export default {
  data() {
    return {
      isVisible: false,
      settingsBcr: null, // bounding client rect of settings
      settingsPosition: 'left', // either 'left' or 'right'
      arrowPositionLeft : 0,
      arrowPositionTop: 0,
      windowWidth: 0,
      windowHeight: 0,
    };
  },
  computed: {
    ...mapGetters([
      ACTIVE_LAYER,
      ACTIVE_LAYER_ID,
      ACTIVE_LAYER_BOUNDING_CLIENT_RECT,
      WINDOW_WIDTH,
      WINDOW_HEIGHT,
    ]),
    layer() {
      return this.ACTIVE_LAYER;
    },
    arrowDiretion() {
      if (this.settingsPosition === 'left') {
        return 'right';
      }
      return 'left';
    },
    arrowStyle() {
      return {
        left: `${this.arrowPositionLeft}px`,
        top: `${this.arrowPositionTop}px`,
      };
    },
    layerStyle() {
      const layerStyle = {};
      const bcr = this.ACTIVE_LAYER_BOUNDING_CLIENT_RECT;
      if (bcr && this.settingsBcr) {
        const layerCenterX = bcr.left + (bcr.width / 2);
        const layerCenterY = bcr.top + (bcr.height / 2);
        if(layerCenterX < this.WINDOW_WIDTH / 2) { // display on the left
          layerStyle.left = `${bcr.left - this.settingsBcr.width - 30}px`;
          this.settingsPosition = 'left';
          this.arrowPositionTop = layerCenterY;
          this.arrowPositionLeft = bcr.left;
        } else { // display on the right
          layerStyle.left = `${bcr.left + bcr.width + 10}px`;
          this.settingsPosition = 'right';
          this.arrowPositionTop = layerCenterY;
          this.arrowPositionLeft = bcr.left + bcr.width;
        }
        let settingsTop = layerCenterY - (this.settingsBcr.height / 2);
        const yOverhang = (settingsTop + this.settingsBcr.height) - this.WINDOW_HEIGHT;
        // if bottom of settings popup is not visible adjust accordingly
        if (yOverhang > 0) {
          settingsTop -= yOverhang
        } else if (settingsTop < 0) { // if top is not visible -> adjust
          settingsTop = 0;
        }
        layerStyle.top = `${settingsTop}px`;
      } else {
        // can be ignored. In the next tick this will be fine
        // log.error('layer or bounding client rect undefined!, bcr: ', bcr, ', settings:', this.settingsBcr);
      }
      return layerStyle;
    },
  },
  methods: {
    /**
     * Stores the bounding client rect (bcr) after the settings element became visible,
     * Needed to position the settings dialog next to the layer that was clicked.
     */
    setSettingsBcr() {
      // We need to wait until the entire view has been rendered,
      // before the bounding client rect is wrong.
      this.$nextTick(function () {
        this.settingsBcr = this.$refs.settings ? this.$refs.settings.getBoundingClientRect() : null;
      })
    },
    checkVisibility() {
      if (this.ACTIVE_LAYER_ID && this.ACTIVE_LAYER_BOUNDING_CLIENT_RECT) {
        this.isVisible = true;
        this.setSettingsBcr();
      } else {
        this.isVisible = false;
      }
    },
  },
  watch: {
    ACTIVE_LAYER_ID() {
      this.checkVisibility();
    },
    ACTIVE_LAYER_BOUNDING_CLIENT_RECT() {
      this.checkVisibility();
    },
  },
  mounted: function () {
    this.setSettingsBcr();
  },
  components: {
    KdImageLayerSettings,
    KdTextLayerSettings,
  },
};
</script>

<style lang="scss">
.kd-layer-settings {
  position: absolute;
  padding-top: 20px;
  width: 244px;
  // the other paddings need to be set by the inner components
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 0px 26px 0px rgba(0,0,0,0.15);

  @media all and (max-height: 680px) {
    padding-top: 12px;
  }
}

.kd-layer-settings__arrow {
  position: fixed; // needed to overcome parent position
  width: 0; 
  height: 0;

  &--right {
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    border-left: 20px solid white;
    transform: translate(-22px, -20px);
  }

  &--left {
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent; 
    border-right:20px solid white;
    transform: translate(2px, -20px);
  }
}
</style>
